import RootLayout from "@/app/layout";
import { useInView } from 'react-intersection-observer';
import { motion } from 'framer-motion';
import { Typography, Container, Box, List, ListItem, ListItemText } from '@mui/material';
import data from '../../data/news/data.json';
import Head from "next/head";

export const metadata = {
  title: 'Hebamme Lea Stiffler | Neuigkeiten',
  canonicalUrl: 'https://hebamme-leastiffler.ch/news'
}

export async function getStaticProps() {
  return { props: { data } }
}

export default function Datenschutz({ data }) {
  const { ref, inView } = useInView({
    threshold: 0.1,
    triggerOnce: true,
  });
  const { Titel, Neuigkeiten } = data;

  return (
    <RootLayout>
      <Head>
        <title>{metadata.title}</title>
        <meta name="description" content={metadata.description} />
        <meta name="keywords" content={metadata.keywords} />
        <link rel="canonical" href={metadata.canonicalUrl} />
      </Head>
      <motion.section
        className="section-large"
        ref={ref}
        initial={{ opacity: 0 }}
        animate={{ opacity: inView ? 1 : 0 }}
        transition={{ duration: 1 }}
      >
        <div className="section-header">
          <div className="section-title">
            <Typography variant="h3" component="h1" gutterBottom align="center">
              {Titel}
            </Typography>
          </div>
        </div>
        <div className="section-body">
          <Container maxWidth="lg">
            <Box sx={{ mt: 4 }}>
              <List>
                {Neuigkeiten.map((item, index) => (
                  <ListItem key={index} sx={{ display: 'block', mb: 2 }}>
                    <ListItemText primary={item} />
                  </ListItem>
                ))}
              </List>
            </Box>
          </Container>
        </div>
      </motion.section>
    </RootLayout>
  );
}
